import { useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
} from "../../ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../ui/tabs";
import {
  Area,
  AreaChart,
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  /* Line,
  LineChart, */
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { SummaryHeader } from "../../ui/SummaryHeader";
import { useChartColors } from "../../../hooks/useChartColors";
import SalesLoader from "../../../components/loaders/SalesLoader";
import { useWholesaleSalesByTime } from "../hooks/useWholesaleSalesByTime";
import { formatCurrency } from "../../../utils/formatCurrency";
import { formatNumber } from "../../../utils/formatNumber";


export function WholesaleSalesByTime() {
   const { monthlySummary, isLoading: isLoadingSalesByTime } = useWholesaleSalesByTime();
  const colors = useChartColors("wholesale");
  const [chartType, setChartType] = useState</* "line" |  */"area" | "bar">("area");
  
      



  if (!colors) return null;

  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;

  const renderChart = (
    data: any[],
    dataKey: string,
    previousYearKey: string,
    formatter: (value: number) => string
  ) => {
    /* if (chartType === "line") {
      return (
        
        <ResponsiveContainer width="100%" height={350}>
          <LineChart
            data={data}
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="monthName" />
            <YAxis tickFormatter={(value) => formatter(value).replace(/[^0-9.KMB]/g, "")} />
            <Tooltip
              formatter={(value) => formatter(Number(value))}
              contentStyle={{
                backgroundColor: "var(--background)",
                borderColor: "var(--border)",
                borderRadius: "var(--radius)",
                fontSize: "0.875rem",
              }}
            />
            <Legend />
            <Line type="monotone" dataKey={dataKey} name={`${currentYear}`} strokeWidth="2" stroke={colors[0]} activeDot={{ r: 8 }} />
            <Line type="monotone" dataKey={previousYearKey} name={`${previousYear}`} strokeWidth="2" stroke={colors[1]} />
          </LineChart>
        </ResponsiveContainer>
      );
    } else  */if (chartType === "area") {
      return (
        <ResponsiveContainer width="100%" height={350}>
          <AreaChart
            data={data}
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="monthName" />
            <YAxis tickFormatter={(value) => formatter(value).replace(/[^0-9.KMB]/g, "")} />
            <Tooltip
              formatter={(value) => formatter(Number(value))}
              contentStyle={{
                backgroundColor: "var(--background)",
                borderColor: "var(--border)",
                borderRadius: "var(--radius)",
                fontSize: "0.875rem",
              }}
            />
            <Legend />
            <Area type="monotone" dataKey={dataKey} name={`${currentYear}`} stroke={colors[0]} fill={colors[0]} fillOpacity={0.3} />
            <Area type="monotone" dataKey={previousYearKey} name={`${previousYear}`} stroke={colors[1]} fill={colors[1]} fillOpacity={0.3} />
          </AreaChart>
        </ResponsiveContainer>
      );
    } else {
      return (
        <ResponsiveContainer width="100%" height={350}>
          <BarChart
            data={data}
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="monthName" />
            <YAxis tickFormatter={(value) => formatter(value).replace(/[^0-9.KMB]/g, "")} />
            <Tooltip
              formatter={(value) => formatter(Number(value))}
              contentStyle={{
                backgroundColor: "var(--background)",
                borderColor: "var(--border)",
                borderRadius: "var(--radius)",
                fontSize: "0.875rem",
              }}
            />
            <Legend />
            <Bar dataKey={dataKey} name={`${currentYear}`} fill={colors[0]} />
            <Bar dataKey={previousYearKey} name={`${previousYear}`} fill={colors[1]} />
          </BarChart>
        </ResponsiveContainer>
      );
    }
  };

  return (
    <>
      <SummaryHeader
        title="Sales over Time"
      />
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              {/* <button
                onClick={() => setChartType("line")}
                className={`px-2 py-1 text-xs rounded ${
                  chartType === "line"
                    ? "bg-primary text-primary-foreground"
                    : "bg-secondary"
                }`}
              >
                Line
              </button> */}
              <button
                onClick={() => setChartType("area")}
                className={`px-2 py-1 text-xs rounded ${
                  chartType === "area"
                    ? "bg-primary text-primary-foreground"
                    : "bg-secondary"
                }`}
              >
                Area
              </button>
              <button
                onClick={() => setChartType("bar")}
                className={`px-2 py-1 text-xs rounded ${
                  chartType === "bar"
                    ? "bg-primary text-primary-foreground"
                    : "bg-secondary"
                }`}
              >
                Bar
              </button>
            </div>
          </div>
        </CardHeader>
        {isLoadingSalesByTime ? (
        <SalesLoader variant="sales-chart"/>
      ) : (
        <CardContent>
          <Tabs defaultValue="orders">
            <TabsList>
              <TabsTrigger value="revenue">Revenue</TabsTrigger>
              <TabsTrigger value="orders">Orders</TabsTrigger>
              <TabsTrigger value="units">Units</TabsTrigger>
            </TabsList>
            <TabsContent
              value="revenue"
              className="w-full h-full p-0 bg-transparent dark:bg-transparent rounded-none shadow-none-soft overflow-visible"
            >
              {renderChart(
                monthlySummary,
                "currentYear.revenue",
                "previousYear.revenue",
                formatCurrency
              )}
            </TabsContent>
            <TabsContent
              value="orders"
              className="w-full h-full bg-transparent dark:bg-transparent rounded-none shadow-none-soft overflow-visible"
            >
              {renderChart(
                monthlySummary,
                "currentYear.orders",
                "previousYear.orders",
                formatNumber
              )}
            </TabsContent>
            <TabsContent
              value="units"
              className="w-full h-full bg-transparent dark:bg-transparent rounded-none shadow-none-soft overflow-visible"
            >
              {renderChart(
                monthlySummary,
                "currentYear.units",
                "previousYear.units",
                formatNumber
              )}
            </TabsContent>
          </Tabs>
        </CardContent>
      )}
      </Card>
    </>
  );
}
